import React, { createContext, useContext, useState } from "react";

const FormStateContext = createContext();

export const useFormState = () => {
    const context = useContext(FormStateContext);
    if (!context) {
        throw new Error("useFormState must be used within a FormStateProvider");
    }
    return context;
};

export const FormStateProvider = ({ children }) => {
    const [formState, setFormState] = useState({
        onHandInventory: "",
        estimated12Months: "",
        numberOfPlants: "",
        numberOfSKUs: "",
        numberOfEmployees: ""
    });

    return (
        <FormStateContext.Provider value={[formState, setFormState]}>
            {children}
        </FormStateContext.Provider>
    );
};